module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG9e6b1607d84622bc32c89ab002e7a44e.9e6b1607.png";